module.exports = __webpack_public_path__ + "static/media/improbable.f47ca6c4.jpg";